import {
  FETCH_DISPUTES,
  FETCH_DISPUTES_SUCCESS,
  FETCH_DISPUTES_FAILED,
  EDIT_DISPUTE
} from "../store/types";

const INITIAL_STATE = {
  disputes: null,
  loading: false,
  error: {
    flag: false,
    msg: null
  }
}

export const disputereducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_DISPUTES:
      return {
        ...state,
        loading: true
      };
    case FETCH_DISPUTES_SUCCESS:
      return {
        ...state,
        disputes: action.payload,
        loading: false
      };
    case FETCH_DISPUTES_FAILED:
      return {
        ...state,
        disputes: null,
        loading: false,
        error: {
          flag: true,
          msg: action.payload
        }
      };
    case EDIT_DISPUTE:
      return state;
    default:
      return state;
  }
};
